var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { neutral40 } from './neutral';
import * as indigo from './indigo';
import * as wine from './wine';
import * as lemon from './lemon';
import * as purple from './purple';
import * as ochre from './ochre';
import * as teal from './teal';
// Default chart colors
export var defaultLight = indigo.indigo30;
export var defaultDark = indigo.indigo20;
// Sequential chart colors (sorted from lowest to highest level)
var indigo80 = indigo.indigo80, indigo10opacity20solidDark = indigo.indigo10opacity20solidDark, indigo30opacity20solidDark = indigo.indigo30opacity20solidDark, indigo40opacity20solid = indigo.indigo40opacity20solid, indigo60opacity20solid = indigo.indigo60opacity20solid, sequentialColors = __rest(indigo, ["indigo80", "indigo10opacity20solidDark", "indigo30opacity20solidDark", "indigo40opacity20solid", "indigo60opacity20solid"]);
export var sequentialLight = __assign({}, sequentialColors);
export var sequentialDark = Object.keys(sequentialColors)
    .reverse()
    .reduce(function (acc, cur) {
    acc[cur] = sequentialColors[cur];
    return acc;
}, {});
// Categorical chart colors
// Order must be kept; if more colors are needed, simply rotate the array
export var categoricalLight = {
    indigo40: indigo.indigo40,
    wine60: wine.wine60,
    lemon60: lemon.lemon60,
    purple70: purple.purple70,
    ochre40: ochre.ochre40,
    teal80: teal.teal80,
    teal60: teal.teal60,
    indigo60: indigo.indigo60,
    wine40: wine.wine40,
    lemon80: lemon.lemon80,
    purple50: purple.purple50,
    ochre60: ochre.ochre60,
};
export var categoricalDark = {
    indigo10: indigo.indigo10,
    wine30: wine.wine30,
    lemon40: lemon.lemon40,
    purple40: purple.purple40,
    ochre20: ochre.ochre20,
    teal60: teal.teal60,
    teal40: teal.teal40,
    indigo30: indigo.indigo30,
    wine10: wine.wine10,
    lemon60: lemon.lemon60,
    purple20: purple.purple20,
    ochre40: ochre.ochre40,
};
export var categoricalLightOpacity20Solid = {
    indigo40: indigo40opacity20solid,
    wine60: wine.wine60opacity20solid,
    lemon60: lemon.lemon60opacity20solid,
    purple70: purple.purple70opacity20solid,
    ochre40: ochre.ochre40opacity20solid,
    teal80: teal.teal80opacity20solid,
    teal60: teal.teal60opacity20solid,
    indigo60: indigo60opacity20solid,
    wine40: wine.wine40opacity20solid,
    lemon80: lemon.lemon80opacity20solid,
    purple50: purple.purple50opacity20solid,
    ochre60: ochre.ochre60opacity20solid,
};
export var categoricalDarkOpacity20Solid = {
    indigo10: indigo10opacity20solidDark,
    wine30: wine.wine30opacity20solidDark,
    lemon40: lemon.lemon40opacity20solidDark,
    purple40: purple.purple40opacity20solidDark,
    ochre20: ochre.ochre20opacity20solidDark,
    teal60: teal.teal60opacity20solidDark,
    teal40: teal.teal40opacity20solidDark,
    indigo30: indigo30opacity20solidDark,
    wine10: wine.wine10opacity20solidDark,
    lemon60: lemon.lemon60opacity20solidDark,
    purple20: purple.purple20opacity20solidDark,
    ochre40: ochre.ochre40opacity20solidDark,
};
// Other colors
export var annotationDefault = neutral40;
export var barColorDefault = indigo.indigo30;
